<template>
    <v-container id="account-nft-view" class="mt-4" fluid>

        <v-alert v-if="$vuetify.breakpoint.mobile" :icon="mdiInformation" dense type="info">
            <div class="d-flex align-center text-subtitle-2 text-lg-subtitle-1 text-no-wrap">
                <span v-if="!$vuetify.breakpoint.mobile" class="mr-1">PLEASE</span><span class="mr-2">NOTE:</span>Branfts.com is still
                <span style="white-space: nowrap" class="d-inline-flex align-center">
                    <icon-base class="ml-2" height="30" width="25" viewBox="0 0 100 100" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                        <icon-b iconColor="rgb(213, 0, 0, 1)" />
                    </icon-base>
                    <span class="ml-n3">eta.<sup>
                        <router-link :to="{ name: 'faq', query: { category: 'general', id: '62193be91416900001d55605' }}" class="text-caption white-no-decoration ml-2" style="text-decoration: none">(What?)</router-link>
                    </sup></span>
                </span>
            </div>
        </v-alert>

        <v-row id="account-branfts">
            <v-spacer></v-spacer>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 10">
                <v-expansion-panels :class="$vuetify.breakpoint.mobile ? 'mobile' : ''" v-model="expansionPanelIndex" popout>
                    <v-expansion-panel :v-if="auth"
                                       v-for="(currentPanelComponent,i) of pageComponents"
                                       :key="i">
                        <v-fade-transition leave-absolute>
                            <v-expansion-panel-header>
                                <template v-slot:default="{ open }">
                                    <v-row class="d-flex align-end mb-4" no-gutters>
                                        <v-col style="min-width: 100px" v-if="!$vuetify.breakpoint.mobile" class="d-flex align-center mr-8 shrink">
                                            <icon-base height="50" width="25" viewBox="0 0 60 80" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                                                <icon-b iconColor="rgb(213, 0, 0, 1)" />
                                            </icon-base>
                                            <span v-if="!$vuetify.breakpoint.mobile" class="text-h6 font-weight-light mt-4 ml-n1">{{ currentPanelComponent.name }}</span>
                                        </v-col>
                                        <v-col
                                               class="text--secondary">

                                            <span class="text-uppercase text-h5"
                                                  v-if="open"
                                                  key="0">
                                                {{ currentPanelComponent.prompt }}
                                            </span>
                                            <span
                                                  class="text-capitalize font-weight-light text-body-1"
                                                  v-else
                                                  key="1">
                                                {{ currentPanelComponent.prompt }}
                                            </span>
                                            <sub class="d-flex mt-1 ml-4 flex-wrap">{{ currentPanelComponent.subprompt }}</sub>

                                        </v-col>
                                        <v-col v-if="!$vuetify.breakpoint.mobile" class="d-flex shrink">
                                            <v-alert :icon="mdiInformation" dense type="info">
                                                <div class="d-flex align-center text-subtitle-2 text-lg-subtitle-1 text-no-wrap">
                                                    <span v-if="!$vuetify.breakpoint.mobile" class="mr-1">PLEASE</span><span class="mr-2">NOTE:</span>Branfts.com is still
                                                    <span style="white-space: nowrap" class="d-inline-flex align-center">
                                                        <icon-base class="ml-2" height="30" width="25" viewBox="0 0 100 100" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                                                            <icon-b iconColor="rgb(213, 0, 0, 1)" />
                                                        </icon-base>
                                                        <span class="ml-n3">eta.<sup><router-link :to="{ name: 'faq', query: { category: 'general', id: '62193be91416900001d55605' }}" class="text-caption white-no-decoration ml-2" style="text-decoration: none">(What?)</router-link></sup></span>
                                                    </span>
                                                </div>
                                            </v-alert>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-expansion-panel-header>
                        </v-fade-transition>
                        <v-expansion-panel-content>
                            <component :is="currentPanelComponent.component"></component>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
    </v-container>
</template>
<style scoped>
.link {
    text-decoration: none;
}
.mobile .v-expansion-panel::before {
    box-shadow: unset !important;
}
</style>
<script>
import { mdiInformation } from "@mdi/js";
import IconB from "./IconB.vue";
import IconBase from "./IconBase.vue";
import { NFTs } from ".";

export default {
    name: "BnftAccountNft",
    props: {},
    components: {
        NFTs,
        IconBase,
        IconB,
    },
    filters: {},
    data: function () {
        return {
            pageComponents: [
                {
                    name: "raNFT™",
                    component: NFTs,
                    prompt: "Studio, Store, and Gallery",
                    subprompt: "Create, sell, and buy truly unique crypto NFTs",
                },
            ],
            mdiInformation,
        };
    },
    computed: {
        expansionPanelIndex: {
            get: function () {
                return this.$store.state["account.expansionPanelIndex"];
            },
            set: function (val) {
                this.$store.commit({
                    type: "set",
                    "account.expansionPanelIndex": val,
                });
            },
        },
        auth: function () {
            if (!this.expansionPanelIndex) return false;
            const panel = this.pageComponents[this.expansionPanelIndex];
            if (panel && panel.name.toLowerCase() === "nfts") {
                return process.env.NODE_ENV !== "production";
            } else {
                return true;
            }
        },
        expandedPanel() {
            const index =
                document.location.hostname.match(/branfts/) &&
                !this.$store.state["account.expansionPanelIndex"]
                    ? 0
                    : 1;
            console.log(index);
            return index;
        },
    },
    mounted() {
        if (
            this.$route.name.match(/account/) &&
            document.location.hostname.match(/branfts.com/)
        ) {
            this.$set(this, "expansionPanelIndex", 0);
        }
    },
    methods: {
        // Log the user in
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
    },
};
</script>
